import api from '../api';
import moment from 'moment';

const cashbackService = {
  create: async (unity: string, points: number, userDocument: string) => {
    const res = await api
      .post('/points', {
        type: 'debit',
        unity,
        points,
        userDocument,
        transactionCode: Math.floor(Math.random() * Date.now())
          .toString(36)
          .toUpperCase(),
        expirationDate: moment().add(6, 'month').toDate(),
        notification_viewed: false,
      })
      .catch((error) => {
        return error.response;
      });

    return res;
  },
};

export default cashbackService;
